import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { AmsRewardsService } from './ams-rewards.service';

angular.module('app-lite.ams-rewards', [])
  .service('amsRewardsApi', downgradeInjectable(AmsRewardsService));
